module.exports = __webpack_public_path__ + "static/media/otaku.ae52663f.jpg";